<template>
  <div class="box">
    <div class="box_title px-5 py-3">
        {{ title }}
    </div>
    <div>
      <slot>
        <p style="min-height: 80px">Content Goes Here</p>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
.box {
  background-color: white;
  border: 4px solid #D7EBFF;
  border-radius: 18px;
}
.box_title {
  font-size: 32px;
  font-weight: bold;
  color: #072846;
}
</style>